import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row mt-4" }
const _hoisted_4 = { class: "col-12 col-lg-6 form-group" }
const _hoisted_5 = { class: "col-12 col-lg-6 form-group" }
const _hoisted_6 = ["data-maska"]
const _hoisted_7 = { class: "col-6 form-group" }
const _hoisted_8 = ["data-maska"]
const _hoisted_9 = { class: "col-6 form-group" }
const _hoisted_10 = ["data-maska"]
const _hoisted_11 = { class: "col-12 form-group" }
const _hoisted_12 = ["data-maska"]

import AddressComponent from '@/components/AddressComponent.vue';
import AppContainer from '@/components/AppContainer.vue';
import CardAcceptedBrands from '@/components/CardAcceptedBrands.vue';
import useOffCanvas from '@/components/Offcanvas/useOffCanvas';
import useCards from '@/composables/useCards';
import useForm from '@/composables/useForm';
import usePayment from '@/composables/usePayment';
import { IAddressResponse } from '@/interfaces';
import paths from '@/router/paths';
import { creditCardValidations } from '@/utils/form_validations';
import { cpfMask, creditCardExpirationDate, creditCardNumberMask, numberMask } from '@/utils/masks';
import useVuelidate from '@vuelidate/core';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddCreditCard',
  setup(__props) {

const { createCard, submitting } = useCards()
const { user_document_number } = usePayment()
const { canvasBackPressed, closeCanvas} = useOffCanvas()
const { invalidForm } = useForm()
const route = useRoute()

const addressResponse = ref<IAddressResponse>({
    address: {
        street: '',
        number: '',
        zip_code: '',
        city: '',
        state: '',
        country: ''
    },
    form: {},
})
const holder_name = ref("")
const number = ref("")
const expiration_date = ref("")
const cvv = ref("")
const document_number = ref(user_document_number)

const $v = useVuelidate(
    creditCardValidations(),
    {
        holder_name,
        number,
        expiration_date,
        cvv,
        document_number,
    }
)

const cardForm = computed(() => {
    let exp_month = ''
    let exp_year = ''
    if (expiration_date.value) {
        exp_month = expiration_date.value.split('/')[0]
        exp_year = expiration_date.value.split('/')[1]
    }

    return {
        holder_name: holder_name.value,
        number: number.value,
        cvv: cvv.value,
        exp_month,
        exp_year,
        document_number: document_number.value
    }
})

const addressChanged = (response: IAddressResponse) => {
    addressResponse.value = response
}

const handleCreateCard = () => {
    $v.value.$touch()
    if (invalidForm($v.value, addressResponse.value?.form)) {
        return
    }
    createCard(addressResponse.value.address, cardForm.value, () => {
        console.log('cartão criado')
        handleCanvasNavigation()
    })
}
const handleCanvasNavigation = () => {
if(route.path == paths.more.root) {
  canvasBackPressed()
} else {
  closeCanvas()
}
}

return (_ctx: any,_cache: any) => {
  const _component_SubmitBtn = _resolveComponent("SubmitBtn")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(AppContainer, { id: "add-credit-card-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(CardAcceptedBrands)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            for: "add_credit_card_name",
            class: "form-label"
          }, "Nome no cartão", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "add_credit_card_name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref($v).holder_name.$model) = $event)),
            placeholder: "João Silva"
          }, null, 512), [
            [
              _vModelText,
              _unref($v).holder_name.$model,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            for: "add_credit_card_number",
            class: "form-label"
          }, "Número do cartão", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "data-maska": _unref(creditCardNumberMask),
            id: "add_credit_card_number",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref($v).number.$model) = $event)),
            placeholder: "0000 0000 0000 0000"
          }, null, 8, _hoisted_6), [
            [_directive_maska],
            [
              _vModelText,
              _unref($v).number.$model,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("label", {
            for: "add_credit_card_expiration_date",
            class: "form-label"
          }, "Validade do cartão", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "add_credit_card_expiration_date",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref($v).expiration_date.$model) = $event)),
            "data-maska": _unref(creditCardExpirationDate),
            placeholder: "12/29"
          }, null, 8, _hoisted_8), [
            [
              _vModelText,
              _unref($v).expiration_date.$model,
              void 0,
              { trim: true }
            ],
            [_directive_maska]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            for: "add_credit_card_cvv",
            class: "form-label"
          }, "CVV", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "data-maska": _unref(numberMask),
            id: "add_credit_card_cvv",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref($v).cvv.$model) = $event)),
            placeholder: "123"
          }, null, 8, _hoisted_10), [
            [_directive_maska],
            [
              _vModelText,
              _unref($v).cvv.$model,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            for: "add_credit_card_document",
            class: "form-label"
          }, "CPF", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "data-maska": _unref(cpfMask),
            id: "add_credit_card_document",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref($v).document_number.$model) = $event)),
            placeholder: "999.999.999-99"
          }, null, 8, _hoisted_12), [
            [_directive_maska],
            [
              _vModelText,
              _unref($v).document_number.$model,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1)),
        _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "fw-bold" }, "Endereço", -1)),
        _createVNode(AddressComponent, { onOnChange: addressChanged }),
        _cache[12] || (_cache[12] = _createElementVNode("p", null, [
          _createElementVNode("small", null, " Nenhuma cobrança será feita antes de uma recarga ser realizada. Estamos adicionando um método de pagamento para facilitar o processo. ")
        ], -1))
      ]),
      _createVNode(_component_SubmitBtn, {
        id: "card-submit-btn",
        loading: _unref(submitting),
        onClick: _withModifiers(handleCreateCard, ["prevent"]),
        title: "Concluir",
        class: "w-100"
      }, null, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

})